import React from 'react';
import {IndexRoute, Route} from 'react-router';
import {
  App,
  Home,
  About,
  HowItWorks,
  VideoTutorials,
  FossilFuelCompanies,
  AboutBanksInsurance,
  CarbonUnderground200,
  Macroclimate50,
  Morningstar,
  CarbonFootprint,
  Clean200,
  Toolkit,
  Media,
  FundRedirect,
  FundFossilFuelInvestments,
  FundCarbonFootprint,
  FundFossilFinanceInvestments,
  FundCleanEnergyInvestments,
  FundInvestmentProfile,
  List,
  Compare,
  Family,
  TspLanding,
  Legal,
  Resources,
  IndexFunds,
  TargetDateSeries,
  Signup,
  NotFound,
  TspToolkit,
  Redirect
} from 'containers'

export default (store) => {
  return (
    <Route path="/" component={App}>
      { /* Home (main) route */ }
      <IndexRoute component={Home}/>

      { /* Routes */ }
      <Route path="/funds/:fundId/:investmentVehicleId/:ticker" component={FundRedirect}/>
      <Route path="/funds/:fundId/:investmentVehicleId" component={FundRedirect}/>
      <Route path="/fund/:name/:ticker/fossil-fuel-investments/:fundId/:investmentVehicleId" component={FundFossilFuelInvestments}/>
      <Route path="/fund/:name/:ticker/carbon-footprint/:fundId/:investmentVehicleId" component={FundFossilFuelInvestments}/>
      <Route path="/fund/:name/:ticker/fossil-finance-insurance/:fundId/:investmentVehicleId" component={FundFossilFinanceInvestments}/>
      <Route path="/fund/:name/:ticker/clean200-investments/:fundId/:investmentVehicleId" component={FundCleanEnergyInvestments}/>
      <Route path="/fund/:name/:ticker/investment-profile/:fundId/:investmentVehicleId" component={FundInvestmentProfile}/>
      <Route path="/funds" component={List}/>
      <Route path="/compare" component={Compare}/>
      <Route path="/families" component={Family}/>
      <Route path="/thrift-savings-plan" component={TspLanding}/>
      <Route path="/about" component={About}/>
      <Route path="/how-it-works" component={HowItWorks}/>
      <Route path="/fossil-fuel-companies" component={FossilFuelCompanies}/>
      <Route path="/video-tutorials" component={VideoTutorials}/>
      <Route path="/carbon-underground-200" component={CarbonUnderground200}/>
      <Route path="/banks-insurance" component={AboutBanksInsurance}/>
      <Route path="/macroclimate-50" component={Macroclimate50}/>
      <Route path="/morningstar" component={Morningstar}/>
      <Route path="/carbon-footprint" component={CarbonFootprint}/>
      <Route path="/clean-200" component={Clean200}/>
      <Route path="/fossil-free-action-toolkit" component={Toolkit}/>
      <Route path="/media" component={Media}/>
      <Route path="/legal" component={Legal}/>
      <Route path="/resources" component={Resources}/>
      <Route path="/index-funds" component={IndexFunds}/>
      <Route path="/target-date-funds" component={TargetDateSeries}/>
      <Route path="/sign-up" component={Signup}/>
      <Route path="/thrift-savings-plan-toolkit" component={TspToolkit}/>

      { /* Redirects */ }
      <Route path="/macroclimate-30" component={Redirect}/>
      <Route path="/university-retirement-plans-funding-destruction-students-future" component={Redirect}/>

      { /* Catch all route */ }
      <Route path="*" component={NotFound} status={404} />
    </Route>
  );
};
